import React, { Component } from 'react';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import './LogoutConfirmation.scss';

type logoutConfirmationContentProps = {
    noAction: any,
    yesAction: any
}

class LogoutConfirmationContent extends Component<logoutConfirmationContentProps, {}>{
    content: any = {
        iconLink: '',
        title: 'Log out',
        body: 'Are you sure you want to logout ? ',
        buttonOneLabel: 'No',
        buttonTwoLabel: 'Yes'
    }

    render () {
        return (
            <div data-test='logoutConfirmationComponent'>
                <DialogTitle id="common-modal-title" className="common-modal-title">
                    <span className="dialog-title">{ this.content.title }</span>
                </DialogTitle>
                <DialogContent className="common-modal-description-root">
                    <DialogContentText className="common-modal-description" id="common-modal-description">
                    <span className="description-content">{ this.content.body }</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="common-modal-actions">
                    <Button className="btn-cancel" variant="outlined" onClick={ this.props.noAction } disableElevation>
                        { this.content.buttonOneLabel }
                    </Button>
                    <Button className="common-modal-button" variant="contained" onClick={ this.props.yesAction } color="primary" disableElevation>
                        { this.content.buttonTwoLabel }
                    </Button>
                </DialogActions>
            </div>
        )
    }
}

export default LogoutConfirmationContent;